import { define } from './define';

// The owner's chat (/chat): the few cards an owner sees most days. Keys start with "chat.".
export const chat = define({
  es: {
    'chat.title': 'Tu asistente de marketing',
    'chat.hi': 'Hola',
    'chat.hiName': 'Hola, {name}',
    'chat.see': 'Ver',
    'chat.planWaiting': 'El plan de {month} espera tu aprobación',
    'chat.allDone': 'Todo al día. Nada espera tu aprobación.',
    'chat.advanced': 'Avanzado',
    'chat.welcome': 'Pregúntame lo que quieras sobre tus posts, el plan o los resultados, o dime qué cambiar.',
    'chat.placeholder': 'Escribe aquí…',
    'chat.suggest.week': 'Enséñame los posts de esta semana',
    'chat.suggest.plan': 'Enséñame el plan del mes',
    'chat.suggest.results': '¿Cómo fue el mes pasado?',
    'chat.loading': 'Cargando…',
    'chat.week.title': { one: '{count} post espera tu aprobación', other: '{count} posts esperan tu aprobación' },
    'chat.week.none': 'No hay nada esperando tu aprobación ahora mismo.',
    'chat.week.confirm': 'Al aprobar confirmas: {items}',
    'chat.week.approveAll': 'Aprobar todos',
    'chat.week.approving': 'Aprobando…',
    'chat.week.approved': { one: 'Aprobado.', other: 'Aprobados los {count}.' },
    'chat.week.byHand': { one: 'Lo publicas tú a mano: aparecerá en Publicar hoy cuando llegue su hora.', other: '{count} los publicas tú a mano: cada uno aparecerá en Publicar hoy cuando llegue su hora.' },
    'chat.week.automatic': { one: 'Saldrá solo en su fecha.', other: '{count} saldrán solos en su fecha.' },
    'chat.week.unscheduled': { one: 'Todavía no tiene fecha para salir.', other: '{count} todavía no tienen fecha para salir.' },
    'chat.week.someFailed': 'No se pudo aprobar: {titles}',
    'chat.week.shown': { one: 'El post que te enseñé', other: 'Los {count} posts que te enseñé' },
    'chat.week.approvedSome': '{count} de {total} aprobados.',
    'chat.week.replaced': 'Cambió después de que lo vieras, así que no se aprobó: {titles}. Pide los posts de esta semana para ver la versión nueva.',
    'chat.week.changesAsked': 'Pediste cambios: {titles}',
    'chat.week.gone': 'Ya no espera tu aprobación: {titles}',
    'chat.week.approveWaiting': { one: 'Aprobar el que queda', other: 'Aprobar los {count} que quedan' },
    'chat.change.title': 'Pedir un cambio',
    'chat.change.send': 'Enviar',
    'chat.change.cancel': 'Cancelar',
    'chat.change.sent': 'Pedido. Te traeré la nueva versión.',
    'chat.change.cancelled': 'Cancelado.',
    'chat.plan.none': 'Aún no hay plan para los próximos meses.',
    'chat.plan.title': 'Plan de {month}',
    'chat.plan.approve': 'Aprobar el plan',
    'chat.plan.approved': 'Plan aprobado.',
    'chat.plan.replaced': 'Una versión más nueva sustituyó este plan. Pide el plan para verla.',
    'chat.plan.changesAsked': 'Pediste cambios. El agente traerá una versión nueva.',
    'chat.plan.waiting': 'Espera tu aprobación',
    'chat.plan.posts': { one: '{count} post', other: '{count} posts' },
    'chat.plan.asks': 'El agente pregunta',
    'chat.planChange.title': 'Pedir cambios en el plan',
    'chat.promo.title': 'Guardar esta promoción',
    'chat.promo.save': 'Guardar',
    'chat.promo.saved': 'Guardada. El agente la tendrá en cuenta.',
    'chat.facts.title': 'Lo que el agente sabe de tu negocio',
    'chat.facts.none': 'Todavía no hay datos del negocio aprobados.',
    'chat.facts.website': 'Estos datos salen de tu web: {url}. Cámbialos allí y el agente los leerá de nuevo.',
    'chat.fact.add': 'Añadir a los datos de tu negocio',
    'chat.fact.update': 'Cambiar un dato de tu negocio',
    'chat.fact.remove': 'Quitar un dato de tu negocio',
    'chat.fact.was': 'Antes: {text}',
    'chat.fact.save': 'Guardar',
    'chat.fact.saved': 'Guardado y aprobado. El agente lo usará desde el próximo post.',
    'chat.fact.unknown': 'No encuentro ese dato.',
    'chat.results.title': 'Últimos 30 días',
    'chat.results.posts': { one: '{count} post publicado', other: '{count} posts publicados' },
    'chat.results.best': 'El que mejor fue: {title}',
    'chat.results.none': 'Todavía no hay números de los últimos 30 días.',
    'chat.error': 'Algo falló: {message}',
    'chat.unavailable': 'No he podido contestar ahora mismo. Vuelve a intentarlo en un minuto.',
    'chat.notSaved': 'Una respuesta no se pudo guardar, así que puede no estar cuando vuelvas. Pregunta otra vez si la necesitas.',
    'chat.interrupted': 'El chat se reinició antes de terminar una respuesta. Pregunta otra vez si la necesitas.',
  },
  en: {
    'chat.title': 'Your marketing assistant',
    'chat.hi': 'Hi',
    'chat.hiName': 'Hi, {name}',
    'chat.see': 'See',
    'chat.planWaiting': 'The {month} plan is waiting for your OK',
    'chat.allDone': 'All caught up. Nothing is waiting for you.',
    'chat.advanced': 'Advanced',
    'chat.welcome': 'Ask me about your posts, the plan or how things are going, or tell me what to change.',
    'chat.placeholder': 'Type here…',
    'chat.suggest.week': 'Show me this week’s posts',
    'chat.suggest.plan': 'Show me the plan',
    'chat.suggest.results': 'How did last month go?',
    'chat.loading': 'Loading…',
    'chat.week.title': { one: '{count} post is waiting for your OK', other: '{count} posts are waiting for your OK' },
    'chat.week.none': 'Nothing is waiting for your OK right now.',
    'chat.week.confirm': 'By approving you confirm: {items}',
    'chat.week.approveAll': 'Approve all',
    'chat.week.approving': 'Approving…',
    'chat.week.approved': { one: 'Approved.', other: 'All {count} approved.' },
    'chat.week.byHand': { one: 'You post it by hand: it shows up in Publish today when its time comes.', other: '{count} are yours to post by hand: each shows up in Publish today when its time comes.' },
    'chat.week.automatic': { one: 'It goes out by itself on its date.', other: '{count} go out by themselves on their dates.' },
    'chat.week.unscheduled': { one: 'It has no date to go out yet.', other: '{count} have no date to go out yet.' },
    'chat.week.someFailed': 'Could not approve: {titles}',
    'chat.week.shown': { one: 'The post you were shown', other: 'The {count} posts you were shown' },
    'chat.week.approvedSome': '{count} of {total} approved.',
    'chat.week.replaced': 'Changed after you saw it, so not approved: {titles}. Ask for this week’s posts to see the new version.',
    'chat.week.changesAsked': 'You asked for changes: {titles}',
    'chat.week.gone': 'No longer waiting for your OK: {titles}',
    'chat.week.approveWaiting': { one: 'Approve the one still waiting', other: 'Approve the {count} still waiting' },
    'chat.change.title': 'Ask for a change',
    'chat.change.send': 'Send',
    'chat.change.cancel': 'Cancel',
    'chat.change.sent': 'Asked. I’ll bring you the new version.',
    'chat.change.cancelled': 'Cancelled.',
    'chat.plan.none': 'There is no plan for the coming months yet.',
    'chat.plan.title': 'Plan for {month}',
    'chat.plan.approve': 'Approve the plan',
    'chat.plan.approved': 'Plan approved.',
    'chat.plan.replaced': 'A newer version replaced this plan. Ask for the plan to see it.',
    'chat.plan.changesAsked': 'You asked for changes. The agent will bring a new version.',
    'chat.plan.waiting': 'Waiting for your OK',
    'chat.plan.posts': { one: '{count} post', other: '{count} posts' },
    'chat.plan.asks': 'The agent asks',
    'chat.planChange.title': 'Ask for changes to the plan',
    'chat.promo.title': 'Save this promotion',
    'chat.promo.save': 'Save',
    'chat.promo.saved': 'Saved. The agent will use it.',
    'chat.facts.title': 'What the agent knows about your business',
    'chat.facts.none': 'There are no approved business facts yet.',
    'chat.facts.website': 'These facts come from your website: {url}. Change them there and the agent reads them again.',
    'chat.fact.add': 'Add to your business facts',
    'chat.fact.update': 'Change a business fact',
    'chat.fact.remove': 'Remove a business fact',
    'chat.fact.was': 'Was: {text}',
    'chat.fact.save': 'Save',
    'chat.fact.saved': 'Saved and approved. The agent uses it from the next post.',
    'chat.fact.unknown': 'I can’t find that fact.',
    'chat.results.title': 'Last 30 days',
    'chat.results.posts': { one: '{count} post published', other: '{count} posts published' },
    'chat.results.best': 'Best one: {title}',
    'chat.results.none': 'No numbers from the last 30 days yet.',
    'chat.error': 'Something went wrong: {message}',
    'chat.unavailable': 'I couldn’t answer just now. Please try again in a minute.',
    'chat.notSaved': 'An answer could not be saved, so it may be gone when you come back. Ask again if you still need it.',
    'chat.interrupted': 'The chat restarted before an answer finished. Ask again if you still need it.',
  },
});
